import React, {useState, useEffect, useContext} from 'react';
import {Button} from 'reactstrap';
import {toast} from 'react-toastify';
import {
    getEntityPreview,
    getEditEntityPreview,
    submitEntityCreation,
    submitEntityUpdate,
    deleteEntity,
    deleteSourceFromAdding,
} from 'utils/api';
import {getAutocompleteData} from 'utils/api/entitiesApi';
import {getRandomColor} from 'utils/other';
import AddTwitterSourceInput from './inputs/AddTwitterSourceInput';
import AddFacebookSortInput from './inputs/AddFacebookSortInput';
import AddRssSourceInput from './inputs/AddRssSourceInput';
import AddYoutubeSourceInput from './inputs/AddYoutubeSourceInput';
import AddInstagramSourceInput from './inputs/AddInstagramSourceInput';
import AddGoogleNewsSourceInput from './inputs/AddGoogleNewsSourceInput';
import AddWebSourceInput from './inputs/WebAddField';
import AddCompanyInput from './AddCompanyInput';
import AddEntityHeader from './AddEntityHeaderNew';
import Loader from 'components/Loader';
import {useHistory, useParams} from 'react-router-dom';
import SourceList from './SourceList';
import {ErrorContext} from 'contexts/ErrorContext';
import {EntityContext} from 'contexts/EntityContext';
import './styleNew.scss';

const AddEntity = () => {
    let {idForEditMode, activeSourceTypeFromUrl} = useParams();
    let {resetEntityFilters, setEntitySocialFilters} = useContext(EntityContext);
    let history = useHistory();

    const {handleErrors} = useContext(ErrorContext);
    const [editingTitle, setEditingTitle] = useState(false);
    const [title, setTitle] = useState('');
    const [tempTitle, setTempTitle] = useState('');
    const [color, setColor] = useState('');
    const [inputValue, setInputValue] = useState('');
    const [activeEntity, setActiveEntity] = useState(null);
    const [fetchingEntityData, setFetchingEntityData] = useState(true);
    const [logoUrl, setLogoUrl] = useState(null);
    const [submittingInfoChanges, setSubmittingInfoChanges] = useState(false);
    const [followBtnSubmitting, setFollowBtnSubmitting] = useState(false);
    const [entityPreviewData, setEntityPreviewData] = useState(null);
    const [activeSourceType, setActiveSourceType] = useState(null);
    const [preventActions, setPreventActions] = useState(false);
    const [autoCompleteData, setAutoCompleteData] = useState({
        domain: null,
        logo: null,
        name: null,
    });

    useEffect(() => {
        if(idForEditMode) {
            fetchEntityDataForEdit();
            if(activeSourceTypeFromUrl) {
                activeSourceTypeFromUrl === 'google_news' ?
                    setActiveSourceType('google_ozmosys')
                    : setActiveSourceType(activeSourceTypeFromUrl);
            }
        } else {
            setFetchingEntityData(false);
        }
    }, []);

    const fetchEntityPreview = async(value, byUrl, autocompleteObj) => {
        try {
            !fetchingEntityData && setFetchingEntityData(true);
            const params = {
                url: value,
                byUrl: !!byUrl,
                domain: autocompleteObj ? autocompleteObj.domain : null,
                logo: autocompleteObj ? autocompleteObj.logo : null,
                name: autocompleteObj ? autocompleteObj.name : null,
            };
            let data = await getEntityPreview(params);
            if(!data.content || !data.content.result || !data.content.result.length) {
                toast.error('Unable to fetch preview data for this URL');
                setFetchingEntityData(false);
                return;
            }
            let entityData = data.content.result[0];
            if(autocompleteObj && autocompleteObj.name) {
                setTitle(autocompleteObj.name);
                setTempTitle(autocompleteObj.name);
            } else if(entityData.domain) {
                let strippedUrl = stripSuffix(entityData.domain);
                setTitle(strippedUrl);
                setTempTitle(strippedUrl);
            } else if(entityData.title) {
                setTitle(entityData.title);
                setTempTitle(entityData.title);
            }
            setAutoCompleteData(autocompleteObj);
            setActiveEntity(entityData);
            autocompleteObj && setLogoUrl(autocompleteObj.logo);
            setFetchingEntityData(false);
            setColor(getRandomColor());
        } catch(err) {
            console.log(err);
            setFetchingEntityData(false);
            if(err.message === 'The access to this website is forbidden') {
                this.getPreview(value, true);
            } else if(err.message && err.message.length < 150) {
                toast.error(err.message);
            }
        }
    };

    const stripSuffix = (url, returnAsLowerCase) => {
        if(!url) return '';
        let strippedUrl = url.substring(0, url.lastIndexOf('.'));
        return returnAsLowerCase ? strippedUrl : strippedUrl.charAt(0).toUpperCase() + strippedUrl.slice(1);
    };

    const fetchEntityDataForEdit = async() => {
        try {
            let data = await getEditEntityPreview(idForEditMode);
            if(!data.content.result || !data.content.result.length) {
                toast.error('Unable to fetch entity');
                history.push('/home');
            }
            let entityData = data.content.result[0];
            setActiveEntity(entityData);
            setLogoUrl(entityData.logoUrl);
            setTempTitle(entityData.title);
            setTitle(entityData.title);
            setColor(getRandomColor());
            setFetchingEntityData(false);
        } catch(err) {
            console.log(err);
            if(err.message && err.message.length < 150) {
                toast.error(err.message);
            }
            if(err.code && err.code === 'NOT_FOUND') history.push('/home');
            setFetchingEntityData(false);
        }
    };

    const fetchEntityLogo = async(domain) => {
        try {
            let logo = await fetch(`https://logo.clearbit.com/${domain}`);
            setLogoUrl(logo.url);
            console.log(logo.url);
        } catch(err) {
            console.log(err);
            setLogoUrl(null);
        }
    };

    const getSourceIcon = (sourceName) => {
        switch(sourceName) {
            case 'twitter':
                return <span style={{fontSize: '20px', color: '#1DA1F2', padding: '0 10px', width: '40px'}}>
                    <i className="fab fa-twitter-square"/>
                </span>;
            case 'facebook':
                return <span style={{fontSize: '18px', color: '#4267B2', padding: '0 10px', width: '40px'}}>
                    <i className="fab fa-facebook"/>
                </span>;
            case 'web':
                return <span style={{fontSize: '18px', color: '#314784', padding: '0 10px', width: '40px'}}>
                    <i className="fa fa-globe"/>
                </span>;
            case 'instagram':
                return <span style={{fontSize: '18px', color: '#E1306C', padding: '0 10px', width: '40px'}}>
                    <i className="fab fa-instagram"/>
                </span>;
            case 'youtube':
                return <span style={{fontSize: '18px', color: '#FF0000', padding: '0 10px', width: '40px'}}>
                    <i className="fab fa-youtube"/>
                </span>;
            case 'rss':
                return <span style={{fontSize: '18px', color: '#ee802f', padding: '0 10px', width: '40px'}}>
                    <i className="fas fa-rss"/>
                </span>;
            case 'google_ozmosys':
                return <span style={{fontSize: '18px', color: '#314784', padding: '0 10px', width: '40px'}}>
                    <i className="fas fa-globe"/>
                </span>;
            default:
                return false;
        }
    };

    const toggleEditingTitle = () => setEditingTitle(prevState => !prevState);

    const addSourceToEntity = (sourceObj, type) => {
        let newSourceObj = {...sourceObj, type};
        let activeEntityClone = {...activeEntity};
        if(!Array.isArray(activeEntityClone.elements)) activeEntityClone.elements = [];

        if(type === 'google_ozmosys') {
            activeEntityClone.elements = activeEntityClone.elements.filter(item => {
                return item.type !== 'google_ozmosys';
            })
        }

        activeEntityClone.elements.length ?
            activeEntityClone.elements = [newSourceObj, ...activeEntityClone.elements]
            : activeEntityClone.elements = [newSourceObj];
        setActiveEntity(activeEntityClone);
        setPreventActions(false);
    };

    const submitOrganizationInfoChanges = async() => {
        try {
            setSubmittingInfoChanges(true);
            const params = {
                title: tempTitle,
                entityId: activeEntity.id,
                ...(!autoCompleteData && {logoUrl: logoUrl}),
                // logoUrl: (autoCompleteData && autoCompleteData.logo) ? null : logoUrl,
            };

            await submitEntityUpdate(params);
            setSubmittingInfoChanges(false);
            // setEditingTitle(false);
            saveEditedTitle();
            // history.push(`/home/${activeEntity.id}`);
        } catch(e) {
            setSubmittingInfoChanges(false);
            if(e.message && e.message.length < 150) {
                toast.error(e.message);
                throw e.message;
            }
        }
    };

    const handleFollowClick = async(autoCompleteInfo) => {
        try {
            !followBtnSubmitting && setFollowBtnSubmitting(true);
            let tempLogoValue;
            let isLogoOk = await getCompanyLogo(null, autoCompleteInfo.logo);
            tempLogoValue = isLogoOk ? autoCompleteInfo.logo : null;
            const params = {
                url: autoCompleteInfo.domain,
                byUrl: true,
                domain: autoCompleteInfo.domain,
                logo: tempLogoValue,
                name: autoCompleteInfo.name,
            };
            let newEntity = await getEntityPreview(params);
            if(!newEntity.content || !newEntity.content.result || !newEntity.content.result.length) {
                toast.error('Unable to fetch preview data for this URL');
                setFollowBtnSubmitting(false);
                return;
            }
            const submitParams = {
                title: newEntity.content.result[0].title,
                entityId: newEntity.content.result[0].id,
            };
            await submitEntityUpdate(submitParams);
            setEntitySocialFilters({
                'twitter': null,
                'facebook': null,
                'youtube': null,
                'rss': null,
                'web': null,
                'instagram': null,
                'google_news': null,
            });
            toast.success('Entity successfully added');
            history.push(`/home/${newEntity.content.result[0].id}`);
            setFollowBtnSubmitting(false);
        } catch(err) {
            setFollowBtnSubmitting(false);
            if(err.message && err.message.slice(0, 37) === 'Entity with same params already exist') {
                let id = err.message.substring(err.message.indexOf('=') + 1, err.message.length);
                id && history.push(`/home/${id.trim()}`);
            } else if(err.message && err.message.length < 150) {
                toast.error(err.message);
                throw err.message;
            }
        }
    };

    const handleManualSubmit = async(url) => { // Needs to be merged with handleFollowClick
        try {
            let companyLogoUrl;
            if(!isValidURL(url)) {
                toast.error('The entered URL is not vald');
                return;
            }
            setFollowBtnSubmitting(true);
            let strippedUrl = url.replace(/^https?\:\/\//i, '');
            console.log(strippedUrl)
            let urlWithoutPrefix = strippedUrl.replace(/^(www\.)/,"");
            let strippedPrefixAndSuffixName = stripSuffix(strippedUrl.toLowerCase(), true).replace(/^(www\.)/,"");
            console.log(strippedPrefixAndSuffixName)
            let tempAutocompleteData = await getAutocompleteData(strippedUrl);
            if(Array.isArray(tempAutocompleteData) && tempAutocompleteData.length > 0) {
                if(tempAutocompleteData[0].domain === strippedUrl) {
                    handleFollowClick(tempAutocompleteData[0]);
                    return;
                }
            }
            let isLogoOk = await getCompanyLogo(strippedUrl);
            if(isLogoOk) {
                companyLogoUrl = `https://logo.clearbit.com/${strippedUrl}`;
            }
            const params = {
                url: url,
                byUrl: true,
                logo: companyLogoUrl,
                // domain: strippedUrl,
                domain: urlWithoutPrefix,
                name: strippedPrefixAndSuffixName
            };
            let newEntity = await getEntityPreview(params);
            if(newEntity.content.result && !newEntity.content.result.length) {
                toast.error('Unable to fetch preview data for this URL');
                this.setState({previewLoading: false});
                return;
            }
            const submitParams = {
                title: newEntity.content.result[0].title,
                entityId: newEntity.content.result[0].id,
            };
            await submitEntityUpdate(submitParams);
            // resetEntityFilters();
            setEntitySocialFilters({
                'twitter': null,
                'facebook': null,
                'youtube': null,
                'instagram': null,
                'google_ozmosys': null,
                'rss': null,
                'web': null,
            });
            setFollowBtnSubmitting(false);
            toast.success('Entity successfully added');
            history.push(`/home/${newEntity.content.result[0].id}`);
        } catch(err) {
            console.log(err);
            setFollowBtnSubmitting(false);
            if(err.message && err.message.slice(0, 37) === 'Entity with same params already exist') {
                let id = err.message.substring(err.message.indexOf('=') + 1, err.message.length);
                id && history.push(`/home/${id.trim()}`);
            } else if(err.message && err.message.length < 150) {
                toast.error(err.message);
                throw err.message;
            }
        }
    };

    const isValidURL = (string) => {
        const res = string.match(/(http(s)?:\/\/.)?(www\.)?[-a-zA-Z0-9@:%._\+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_\+.~#?&//=]*)/g);
        return (res !== null);
    };

    const getCompanyLogo = (domain, fullUrl) => {
        let url = fullUrl ? fullUrl : `https://logo.clearbit.com/${domain}`;
        return fetch(url)
            .then(response => {
                return response.ok;
            })
            .catch(err => {
                return false;
                // throw err;
            });
    };


    const cancelAdding = async() => {
        if(activeEntity) {
            await deleteEntity(activeEntity.id);
        }
        history.push('/home');
    };

    const cancelEditingTitle = () => {
        setEditingTitle(null);
        activeEntity && activeEntity.name && setTempTitle(activeEntity.title);
    };

    const saveEditedTitle = () => {
        setEditingTitle(false);
        setTitle(tempTitle);
    };


    const getSourceInput = () => {
        switch(activeSourceType) {
            case 'twitter':
                return <AddTwitterSourceInput activeEntityId={activeEntity.id}
                                              addSourceToEntity={addSourceToEntity}
                                              setPreventActions={setPreventActions}/>;
            case 'facebook':
                return <AddFacebookSortInput activeEntityId={activeEntity.id}
                                             addSourceToEntity={addSourceToEntity}
                                             setPreventActions={setPreventActions}/>;
            case 'web':
                return <AddWebSourceInput activeEntityId={activeEntity.id}
                                          addSourceToEntity={addSourceToEntity}
                                          setPreventActions={setPreventActions}/>;
            case 'youtube':
                return <AddYoutubeSourceInput activeEntityId={activeEntity.id}
                                              addSourceToEntity={addSourceToEntity}
                                              setPreventActions={setPreventActions}/>;
            case 'instagram':
                return <AddInstagramSourceInput activeEntityId={activeEntity.id}
                                                addSourceToEntity={addSourceToEntity}
                                                setPreventActions={setPreventActions}/>;
            case 'rss':
                return <AddRssSourceInput activeEntityId={activeEntity.id}
                                          addSourceToEntity={addSourceToEntity}
                                          setPreventActions={setPreventActions}/>;
            case 'google_ozmosys':
                return <AddGoogleNewsSourceInput
                    activeEntityId={activeEntity.id}
                    addSourceToEntity={addSourceToEntity}
                    setPreventActions={setPreventActions}
                    disabled={(activeEntity.elements && activeEntity.elements.find(item => item.type === 'google_ozmosys'))}
                />;
            default:
                return false;
        }
    };

    return (
        <div className="add-entity mt-3">
            <div className="add-entity__inner">
                <div className="add-entity__header d-flex justify-content-between align-items-center mt-3 mb-3">
                    <h1>{idForEditMode ? 'Edit' : 'Create'} Entity</h1>
                    {!followBtnSubmitting &&
                    <div className="add-entity__buttons">
                        <>
                            {!idForEditMode &&
                            <Button style={{color: 'white'}} onClick={cancelAdding}>
                                Cancel
                            </Button>
                            }
                            <Button
                                style={{minWidth: '84px', marginLeft: '10px'}}
                                disabled={!idForEditMode && (fetchingEntityData || !(activeEntity && activeEntity.elements && activeEntity.elements.length > 0))}
                                onClick={() => history.push(`/home/${activeEntity.id}`)}
                                className="btn calltoaction-button"
                            >
                                Return to Homepage
                            </Button>
                        </>
                    </div>
                    }
                </div>
                <div className="w-100 d-flex">
                    <div className="d-flex justify-content-center w-100">
                        <div className="add-entity__main">
                            {(fetchingEntityData || followBtnSubmitting) ?
                                <div className="flex-centered" style={{width: '100%', height: '300px'}}>
                                    {/*<i className="fa fa-spinner fa-spin"/>*/}
                                    <div className="d-flex flex-column justify-content-center align-items-center">
                                        <Loader/>
                                        {followBtnSubmitting && <div className="mt-2">Generating sources...</div>}
                                    </div>
                                </div>
                                :
                                activeEntity ?
                                    <>
                                        <AddEntityHeader
                                            editId={idForEditMode}
                                            activeEntity={activeEntity}
                                            color={color}
                                            logoUrl={logoUrl}
                                            editingTitle={editingTitle}
                                            tempTitle={tempTitle}
                                            title={title}
                                            setTempTitle={setTempTitle}
                                            cancelEditingTitle={cancelEditingTitle}
                                            // saveEditedTitle={saveEditedTitle}
                                            toggleEditingTitle={toggleEditingTitle}
                                            activeSourceType={activeSourceType}
                                            setActiveSourceType={setActiveSourceType}
                                            autoCompleteData={autoCompleteData}
                                            setEditingTitle={setEditingTitle}
                                            submitOrganizationChanges={submitOrganizationInfoChanges}
                                            submitting={submittingInfoChanges}
                                            preventActions={preventActions}
                                        />
                                        <div className="add-entity-source-input"
                                             style={activeSourceType ? {} : {margin: '0'}}>
                                            {activeSourceType && getSourceInput()}
                                        </div>
                                        <SourceList
                                            activeEntity={activeEntity}
                                            setActiveEntity={setActiveEntity}
                                            handleErrors={handleErrors}
                                            preventActions={preventActions}
                                            setPreventActions={setPreventActions}
                                        />
                                    </>
                                    :
                                    <AddCompanyInput
                                        onSubmit={fetchEntityPreview}
                                        value={inputValue}
                                        handleChange={setInputValue}
                                        loading={fetchingEntityData}
                                        inputPlaceholder="Enter the entity name or URL to research social media"
                                        //cleanPreview={this.cleanPreview}
                                        disabled={!!entityPreviewData}
                                        handleFollowClick={handleFollowClick}
                                        followBtnSubmitting={followBtnSubmitting}
                                        handleManualSubmit={handleManualSubmit}
                                    />
                            }
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default AddEntity;
